// Get visible products

export default (userproduct, { text }) => {
  return userproduct.filter((product) => {
    const textMatch = product.title.toLowerCase().includes(text.toLowerCase());
    return textMatch;
  });
};
